import { defineComponent as _defineComponent } from 'vue'
import { offset, size } from '@floating-ui/vue'
import { ref } from 'vue'

import { useDismiss, useHover, usePopover } from '@/composables/popover'
import type { AnnotatablePlace } from '@/types/assistant'
import { LocationAutocompleteResult } from '@/types/trip.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'FlightCompensationPopover',
  emits: ["place-selected", "location-selected"],
  setup(__props) {



const isOpen = ref(false)

const { referenceRef, floatingRef, floatingStyles } = usePopover({
  placement: 'bottom-end',
  isOpen,
  middleware: [
    offset(4),
    size({
      padding: 16,
      apply({ availableWidth, availableHeight, elements }) {
        Object.assign(elements.floating.style, {
          // Let the popover grow and shrink between 384px and 448px in height
          maxHeight: `${availableHeight}px`,
          maxWidth: `${availableWidth}px`,
        })
      },
    }),
  ],
})
useDismiss({ referenceRef, floatingRef, isOpen })
const listeners = useHover({ isOpen, openDelay: 150, closeDelay: 50 })

// Prevent default tab behavior when the popover is open
function onKeyDown(event: KeyboardEvent) {
  if (event.key === 'Tab' && isOpen.value) {
    event.preventDefault()
    event.stopPropagation()
  }
}

return { __sfc: true,isOpen, referenceRef, floatingRef, floatingStyles, listeners, onKeyDown }
}

})